export enum StatusEnum {
  inProgress = 'InProgress',
  successful = 'Successful',
  dataPullFailed = 'DataPullFailed',
  dataPullPartiallyFailed = 'DataPullPartiallyFailed',
  pending = 'Pending',
}
